var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8641 16.7392L12.0908 21.5125C11.882 21.7215 11.6341 21.8873 11.3613 22.0004C11.0884 22.1135 10.7959 22.1717 10.5006 22.1717C10.2052 22.1717 9.91273 22.1135 9.63988 22.0004C9.36702 21.8873 9.11913 21.7215 8.91038 21.5125L4.13588 16.7392C2.87725 15.4805 2.02013 13.8768 1.6729 12.131C1.32567 10.3852 1.50393 8.57562 2.18513 6.93111C2.86634 5.2866 4.01989 3.88102 5.49992 2.89211C6.97995 1.9032 8.71999 1.37537 10.5 1.37537C12.28 1.37537 14.0201 1.9032 15.5001 2.89211C16.9801 3.88102 18.1337 5.2866 18.8149 6.93111C19.4961 8.57562 19.6743 10.3852 19.3271 12.131C18.9799 13.8768 18.1228 15.4805 16.8641 16.7392Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 10.375C13.875 11.2701 13.5194 12.1286 12.8865 12.7615C12.2536 13.3944 11.3951 13.75 10.5 13.75C9.60489 13.75 8.74645 13.3944 8.11351 12.7615C7.48058 12.1286 7.125 11.2701 7.125 10.375C7.125 9.47989 7.48058 8.62145 8.11351 7.98851C8.74645 7.35558 9.60489 7 10.5 7C11.3951 7 12.2536 7.35558 12.8865 7.98851C13.5194 8.62145 13.875 9.47989 13.875 10.375Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapPin);
export default __webpack_public_path__ + "static/media/ico_map_pin.e2b5d1fb7700c9320af192514f3ede67.svg";
export { ForwardRef as ReactComponent };